<template>
    <div>
        <div class="page-title">Send Template</div>
        <div class="page-box">
            <div class="page-box-title">
                <el-dropdown v-if="applicationFormIds.length>0" split-button @command="handleCommand">
                    {{applicationFormIds.length}} User selected
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="b">Batch Send Announcement & Email </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" @click="show3 = !show3"> 
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17.99993896484375" height="18" viewBox="0 0 17.99993896484375 18" fill="none">
                    <path d="M17.1553 0L0.844728 0C0.0952694 0 -0.282905 0.909349 0.248128 1.44038L6.74998 7.94321L6.74998 15.1875C6.74998 15.4628 6.88431 15.7208 7.10987 15.8787L9.92236 17.8467C10.4772 18.2351 11.25 17.8415 11.25 17.1555L11.25 7.94321L17.752 1.44038C18.2819 0.910403 17.9064 0 17.1553 0Z"   fill="#FFFFFF" >
                    </path>
                    </svg>
                    Filter
                </el-button>
            </div>
            <div class="search-box">
                 <el-collapse-transition>
                <el-form label-width="180px" v-show="show3" :model="formLabelAlign">
                    <el-form-item label="Applicant">
                        <el-input v-model="formLabelAlign.likeApplicant"></el-input>
                    </el-form-item>
                    <el-form-item label="Stage">
                            <el-select v-model="formLabelAlign.stage" placeholder="">
                                <el-option
                                v-for="item in applicationStage"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                    </el-form-item>
                    <el-form-item label="Status">
                        <el-select v-model="formLabelAlign.status" placeholder="">
                                <el-option
                                v-for="item in applicationStatus"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="warning" @click="onSearch">Search</el-button>
                        <el-button icon="el-icon-refresh-left" @click="onReset">Reset</el-button>
                    </el-form-item>
                </el-form>
                 </el-collapse-transition>
            </div>
            <el-table
            :data="application"
             @selection-change="handleSelectionChange"
            style="width: 100%;">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="registrationNo"
                    label="Registration"
                    >
                </el-table-column>
                <el-table-column
                    prop="applicantName"
                    label="Applicant"
                    >
                 <template slot-scope="{row}">
                      <span v-if="row.applicantName">{{JSON.parse(row.applicantName).en}}</span>
                 </template>
                </el-table-column>
                <el-table-column
                    prop="applicationDate"
                    label="Application Date">
                    <template slot-scope="{row}">
                          <span>{{row.applicationDate | formatDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="stage"
                    label="Stage">
                    <template slot-scope="{row}">
                           <span>{{row.stage | applicationStage}}</span>
                    </template>
                </el-table-column>
              
                <el-table-column
                    prop="status"
                    label="Status">
                    <template slot-scope="{row}">
                           <span>{{row.status | applicationStatus}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="checkbox-page">
                <el-radio-group v-model="checkList">
                    <el-radio name="type" v-for="(item,index) in sendType " :key="index" :label="item.value">{{item.label}}</el-radio>
                </el-radio-group>
                <el-button  type="warning" class="send-button" @click="onSend">Send</el-button>
            </div>
            <loadingSlotDialog @close="close" :centerDialogVisible="centerDialogVisible">
                <batchSendAnnouncement :isSendTemplate="true"  @closeCenter="closeCenter" :formType="formType" :applicationFormIds="applicationFormIds"></batchSendAnnouncement>
            </loadingSlotDialog>
        </div>
    </div>
</template>

<script>
    import {getTemplatesDetail} from '@/api/admin/notification'
    import {getApplication,batchSendAnnouncementEmails} from '@/api/admin/application'
    import loadingSlotDialog from '@/components/loadingSlotDialog'
    import batchSendAnnouncement from '@/components/batchSendAnnouncement'
    export default {
        props:{
            
          formType:{
            type:Number,
            default:0
          },
          id:{
            type:Number,
            default:0}
        },
        components:{loadingSlotDialog,batchSendAnnouncement},
        data() {
            return {
                detail:{},
                applicationFormIds:[],
                checkList:null,
                show3:true,
                application:[],
                centerDialogVisible:false,
                formLabelAlign: {
                    likeApplicant: '',
                    stage: '',
                    status: ''
                }
            }
        },
        created(){
            this.getApplication()
            this.getTemplatesDetail()
        },
        methods:{
            handleSelectionChange(v){
              this.applicationFormIds = v.map((item)=>{
                  return item.id
              })

            },
            onSend(){
                this.batchSendAnnouncementEmails()
            },
            closeCenter(v){
                this.centerDialogVisible = v
            },
            close(v){
                this.centerDialogVisible = v
            },
            handleCommand(v){
                if(v=='b'){
                    this.centerDialogVisible = true
                }
            },
            onReset(){
               Object.keys(this.formLabelAlign).forEach((key)=>{
                   this.formLabelAlign[key] = null
               })
                this.getApplication()
            },
          
            onSearch(){
                this.getApplication()
            },
            getTemplatesDetail(){
                getTemplatesDetail(this.id).then((v)=>{
                    this.detail = v.data
                })
            },
            batchSendAnnouncementEmails(){
                 let from = {
                    applicationFormIds: [
                        ...this.applicationFormIds
                    ],
                    type: 0,
                    templateType: this.detail.type,
                    templateId: this.detail.id,
                    sendType: this.checkList
                }
                batchSendAnnouncementEmails(from).then(()=>{
                    //
                    this.$message({
                        message: 'Success',
                        type: 'success'
                    });
                    this.getApplication()
                })
            },
            getApplication(){
                let from =  {
                    formType:this.formType,
                    likeApplicant: this.formLabelAlign.likeApplicant,
                    stage: this.formLabelAlign.stage,
                    status: this.formLabelAlign.status
                }
                getApplication(from).then((v)=>{
                    this.application = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
}
.page-box-title{
    display: flex;
    border-bottom: 1px solid #707070;
    padding: 0 47px;
    padding-top:46px;
    padding-bottom: 27px;
}
.search-box{
    padding-top: 50px;
    padding-bottom: 40px;
    padding-left: 50px;
    padding-right: 50px;
}
.checkbox-page{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
    margin-right: 30px;
    padding-bottom: 30px;
}
.send-button{
    margin-left: 30px;
}
  .el-button--primary {
    width: auto;
    background-color:  #060C60;
    border-color: #060C60;
    font-size: 20px;
    font-weight: bold;
  }
</style>